import Glide from '@glidejs/glide';

const setControlsAndImageHeight = (el) => {
  const images = Array.from(el.querySelectorAll('.glide__image-inner'));
  // Reset all image heights to auto
  images.forEach(img => {
    img.style.height = 'auto';
  });
  // Find the shortest image among the images in the carousel
  // Get the height of the shortest .glide__image-inner
  const minHeight = images.reduce((min, img) => {
    const h = img.offsetHeight;
    return min === null || h < min ? h : min;
  }, null);
  // Set all .glide__image-inner elements to the height of the shortest one
  if (minHeight !== null) {
    images.forEach(img => {
      img.style.height = `${minHeight}px`;
    });
  }
  // Get controls
  const controlContainer = el.querySelector('.glide__arrows');
  const controlContainerHeight = controlContainer.offsetHeight;
  controlContainer.style.top = `${minHeight / 2 - controlContainerHeight / 2}px`;
}

function init(el) {
  const carousel = new Glide(el);
  carousel.on(['build.after', 'resize'], () => {
    setControlsAndImageHeight(el);     
  });

  carousel.mount();
}

export default function() {
  const carousels = Array.from(document.querySelectorAll('.js-carousel'));
  if (!carousels.length) {
    return;
  }
  carousels.forEach(carousel => init(carousel));
}
